<script>
import { mapActions, mapState, mapGetters } from "vuex";

import orderMixin from "@/mixins/orderMixin";
import currencyMixin from "@/mixins/generic/currencyMixin";

export default {
  mixins: [orderMixin, currencyMixin],

  data() {
    return {
      couponName: "",
      error: null,
      useAccountBalance: false
    };
  },

  methods: {
    ...mapActions("payable", [
      "checkCoupon",
      "applyCoupon",
      "setAccountBalance"
    ]),

    async applyPayableCoupon() {
      this.error = null;

      if (!this.couponName) {
        return;
      }

      try {
        const coupon = await this.checkCoupon(this.couponName);

        if (coupon) {
          await this.applyCoupon(coupon.id);
        }
      } catch (e) {
        this.error = e;
      }
    }
  },

  computed: {
    ...mapState("payable", ["payable", "preloaderCoupon", "accountBonus"]),
    ...mapGetters("payable", ["canPayWithAccountBalance"]),
    ...mapState("user", ["user"])
  }
};
</script>

<template>
  <div class="coupon">
    <h4>Saldo em crédito disponível</h4>

    <div>
      <label class="checkbox">
        <input
          class="save-checbox"
          :error="errors.first('store')"
          name="save-checkbox"
          v-model="useAccountBalance"
          type="checkbox"
          @change="setAccountBalance()"
          :disabled="accountBonus || canPayWithAccountBalance"
        >
        <span>Selecione essa opção se deseja criar utilizar o saldo em créditos para abater parte do valor da limpeza.</span>
      </label>

      <div class="amount">{{ user.payment_gateway_account.wallet.available_to_use | toCurrency }}</div>
    </div>
  </div>
</template>

<style scoped>
.coupon {
  border-bottom: solid 1px #e2e2e2;
  margin-bottom: 8px;
  padding-bottom: 8px;
}

h4 {
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 400;
  color: #424242;
}

p {
  margin: 8px 0;
  font-size: 13px;
  font-weight: 300;
  color: #888;
}

.amount {
  width: 100%;
  font-weight: 500;
  text-align: end;
  color: #af006b;
}

form {
  display: flex;
  flex-direction: row;
}

button {
  width: 100%;
  max-width: 100%;
  height: 37px;
  margin-top: 8px;
  border: 0;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #af006b;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
}

button:hover {
  background-color: var(--pink-dark);
}

.button-disabled {
  opacity: 0.25;
}

.disabled {
  display: none;
}

.button-loading:before {
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 24px;
  background-clip: padding-box;
  border: rgba(255, 255, 255, 0.25) 2px solid;
  border-top-color: #fff;
  animation: animation-rotate 750ms linear infinite;
}

.button-loading span,
.button-loading:hover span,
.button-loading:active span {
  display: none;
}

.warning {
  margin-top: 12px;
  border-left: solid 1px #af006b;
  color: #af006b;
  padding-left: 8px;
  font-size: 12px;
}

.custom-button {
  width: 50%;
  max-width: 150px;
  margin: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

@keyframes animation-rotate {
  100% {
    transform: rotate(360deg);
  }
}

.checkbox {
  display: flex;
  align-items: center;
  font-size: 12px;
}

.checkbox b {
  font-weight: 400;
}

.save-checbox {
  margin-right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payable/OrderComponents/AccountBalance.vue